import React from "react";

import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import axios from '../../axios/axiosconf';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

function Settings() {

    const [client, setClient] = useState([]);
    const [permisos, setPermisos] = useState([]);

    useEffect(() => {

        if (!localStorage.getItem('userdata')) {
            setPermisos([]);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));
        let permisosList = [];
        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            permisosList = userdata.permissions.map(p => p.slug);
        } else if (userdata.up) {
            permisosList = userdata.up;
        }
        setPermisos(permisosList);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
            })
            .catch(() => { });
    }, []);

    return (
        <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
            <Header client={client} />
            <Aside client={client} activelink="settings" />

            <div className="content-wrapper">
                <div className="content-header">
                    <div className="container-fluid">
                        <div className="row mb-2">
                            <div className="col-sm-12">
                                <ol className="breadcrumb float-sm-left mb-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item active">Configuración</li>
                                </ol>
                            </div>
                        </div>
                        <div className="row mb-2 align-items-end">
                            <div className="col-md-8">
                                <div className="dash-wrap">
                                    <h1 className="dash-title">Configuración</h1>
                                    <p className="dash-subtitle mb-0">Módulos administrativos del consultorio</p>
                                </div>
                            </div>
                            <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                    <i className="fas fa-arrow-left mr-1"></i> Volver al inicio
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
                <section className="content">
                    <div className="container-fluid">
                        <div className="dash-card mb-4">
                            <div className="dash-card-header">
                                <h2 className="dash-card-title">
                                    <span className="title-icon" aria-hidden="true"><i className="fas fa-sliders-h"></i></span>
                                    Módulos
                                </h2>
                            </div>
                            <div className="dash-card-body">
                                <div className="quick-grid">
                                    {permisos.includes('administrarPersonalProveedores') && (
                                        <Link to="/personal-proveedores" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-users"></i></div>
                                            <p className="quick-title">Personal y proveedores</p>
                                            <p className="quick-sub">Colaboradores, Cargos y Proveedores</p>
                                        </Link>
                                    )}

                                    {permisos.includes('administrarPlantillas') && (
                                        <Link to="/administrar-plantillas" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-file-alt"></i></div>
                                            <p className="quick-title">Plantillas</p>
                                            <p className="quick-sub">Documentos y Plantillas Clínicas</p>
                                        </Link>
                                    )}

                                    {permisos.includes('administrarTratamientos') && (
                                        <Link to="/administrar-tratamientos" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-calculator"></i></div>
                                            <p className="quick-title">Módulo contable</p>
                                            <p className="quick-sub">Tratamientos y Tarifas</p>
                                        </Link>
                                    )}

                                    {permisos.includes('administrarParametrosAgenda') && (
                                        <Link to="/parametros-agenda" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-calendar-alt"></i></div>
                                            <p className="quick-title">Parámetros de agenda</p>
                                            <p className="quick-sub">Configuración de Citas</p>
                                        </Link>
                                    )}

                                    {permisos.includes('administrarParametrosSistema') && (
                                        <Link to="/parametros-sistema" className="quick-card">
                                            <div className="quick-ico"><i className="fas fa-cogs"></i></div>
                                            <p className="quick-title">Parámetros del sistema</p>
                                            <p className="quick-sub">Ajustes Generales del Sistema</p>
                                        </Link>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer showToast={false} delay={0} />
        </div>
    );
}
export default Settings;
